// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExploreSearchResultTitle__wrapper__NucC5"};